import { type WeeklyData } from '@/services/api'
import styles from './WeeklyChart.module.css'

interface Props {
  data: WeeklyData[]
}

export default function WeeklyChart({ data }: Props) {
  const maxCount = Math.max(...data.map(d => d.count), 1)
  const today = new Date().toISOString().split('T')[0]

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>This Week</h3>
      <div className={styles.chart}>
        {data.map((item) => (
          <div key={item.day} className={styles.column}>
            <div className={styles.barWrapper}>
              <div
                className={`${styles.bar} ${item.date === today ? styles.barToday : ''}`}
                style={{ height: `${(item.count / maxCount) * 100}%` }}
              />
            </div>
            <span className={`${styles.dayLabel} ${item.date === today ? styles.dayToday : ''}`}>
              {item.day}
            </span>
            {item.count > 0 && (
              <span className={styles.countLabel}>{item.count}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
